import { Chip } from '@mui/material'

export function WishedPositionChip() {
  return <Chip size="small" variant="outlined" color="primary" label="Poste souhaité" />
}

export function AvailableChip() {
  return <Chip size="small" variant="outlined" color="success" label="Disponible" />
}
